export default "__VITE_ASSET__DSL41INX__"